import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { AuthenticationModule } from './authentication/authentication.module';
import { OperationModule } from './operation/operation.module';
import { PositionModule } from './position/position.module';
import { RegisterModule } from './register/register.module';
import { ProjectsRepositoryRegisterModule } from './projects-repository/register/register.module';
import { ProjectsRepositoryConsultModule } from './projects-repository/consult/consult.module';
import { ProjectsRepositoryRegisterConfirmationModule } from './projects-repository/register-confirmation/register-confirmation.module';
import { EmissionCreditRegisterModule } from './emission-credit/register/emission-credit-register.module';
import { EmissionCreditConsultModule } from './emission-credit/consult/emission-credit-consult.module';
import { EmissionCreditVisualizationModule } from './emission-credit/visualization/emission-credit-visualization.module';
import { ProjectsRepositoryRegisterVisualizationModule } from './projects-repository/register-visualization/register-visualization.module';
import { ProjectsRepositoryProjectRegisterValidationModule } from './projects-repository/register-validation/register-validation.module';
import { HomeModule } from './home/home.module';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    HomeModule,
    RegisterModule,
    OperationModule,
    AuthenticationModule,
    PositionModule,

    ProjectsRepositoryRegisterModule,
    ProjectsRepositoryConsultModule,
    ProjectsRepositoryRegisterConfirmationModule,
    ProjectsRepositoryRegisterVisualizationModule,
    ProjectsRepositoryProjectRegisterValidationModule,
    EmissionCreditRegisterModule,
    EmissionCreditConsultModule,
    EmissionCreditVisualizationModule

  ]
})
export class PagesModule { }
